// @ts-strict-ignore
import { OrderedPosts } from 'src/modules/community/communityPosts/components/orderedPosts';
import i18n from 'src/utils/translate';
import { useDispatch, useSelector } from 'src/store/store';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Section } from 'src/constants/footfall';
import { WriteLink } from 'src/modules/community/shared/components/writeButton';
import { fetchPosts } from 'src/modules/community/communityPosts/actions';
import Button from 'src/components/buttons/button';
import { ResultsSeeMoreCTA, ResultsList } from 'styles-js/resultsList';
import PostListLoader from 'src/modules/shared/resultsList/components/postListLoader';
export function PostList() {
  const dispatch = useDispatch();
  const {
    isArchived,
    slug
  } = useSelector(({
    context
  }) => context.currentCommunity);
  const {
    archive = {},
    filter = 'latest',
    hasMorePosts,
    isPostListLoading,
    posts = [],
    selectedTopic = '',
    selectedTopicId
  } = useSelector(({
    pages
  }) => pages.communityPosts);
  const handleSeeMoreClick = () => {
    // Optional parameter at the end is a flag when the user clicks on this button
    dispatch(fetchPosts({
      communitySlug: slug,
      filter,
      topicId: selectedTopicId,
      topicName: selectedTopic,
      isSeeMoreClick: true
    }));
    trackFootfallEvent(Event.Clicked, {
      clickType: 'see-more-posts',
      clickMetadata: {
        section: Section.CommunityPosts
      }
    });
  };
  if (isPostListLoading) return <PostListLoader />;
  const isPoll = filter === 'polls';
  if (posts.length > 0) {
    return <ResultsList data-testid="results-posts">
        <OrderedPosts />
        {hasMorePosts && !archive.currentYear && <ResultsSeeMoreCTA>
            <Button type="secondary" onClick={handleSeeMoreClick}>
              {isPoll ? i18n.t('See more polls') : i18n.t('See more posts')}
            </Button>
          </ResultsSeeMoreCTA>}
      </ResultsList>;
  } else {
    return !isArchived && <div className="community__home-empty">
          {isPoll ? i18n.t('No polls yet, check back soon') : <>
                {i18n.t('Nothing here yet.')}
                {' '}
                <WriteLink trackingSection={Section.CommunityPosts}>{i18n.t('Share your experience!')}</WriteLink>
              </>}
        </div>;
  }
}